"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebApp = void 0;
/* eslint-disable react/jsx-max-depth */
const VisaType_1 = __importDefault(require("@opsbase/lib-auth/VisaType"));
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_logger_1 = __importDefault(require("@opsbase/lib-logger"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const SelfController_1 = __importDefault(require("@opsbase/react-ctrl-self/SelfController"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const react_useauth_1 = __importDefault(require("@opsbase/react-useauth"));
const AlertWatcherController_1 = __importDefault(require("@opsbase/web-alertwatcher/AlertWatcherController"));
const AppStateController_1 = __importDefault(require("@opsbase/web-app-state/AppStateController"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const NewDataController_1 = __importDefault(require("@opsbase/web-ctrl-newdata/NewDataController"));
const SysLangController_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController"));
const ViewController_1 = __importDefault(require("@opsbase/web-ctrl-view/ViewController/ViewController"));
const SelectionController_1 = __importDefault(require("@opsbase/web-data-selection/SelectionController"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const NotificationController_1 = __importDefault(require("@opsbase/web-notification/NotificationController"));
const NotificationHandler_1 = __importDefault(require("@opsbase/web-notification/NotificationHandler/NotificationHandler"));
const useNotificationActions_1 = __importDefault(require("@opsbase/web-notification/useNotificationActions"));
const TaskWatcherController_1 = __importDefault(require("@opsbase/web-taskwatcher/TaskWatcherController"));
const FeaturedRoute_1 = __importDefault(require("@opsbase/web-ui/FeaturedRoute"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const axios_1 = __importDefault(require("axios"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const OTPSignIn_1 = __importDefault(require("../auth/OTPSignIn"));
const ga_1 = __importDefault(require("../modules/ga"));
const RedirectToNativeAppPage_1 = __importDefault(require("../pages/RedirectToNativeAppPage"));
const ignoreErrors_1 = __importDefault(require("./ignoreErrors"));
const WebAppDataManager_1 = __importDefault(require("./WebAppDataManager"));
const WebAppRoot_1 = __importDefault(require("./WebAppRoot"));
const WebAppRootWithHero_1 = __importDefault(require("./WebAppRootWithHero"));
function WebApp(props) {
    const { rootDiv } = props, appState = __rest(props, ["rootDiv"]);
    const content = (0, react_1.useMemo)(() => react_1.default.createElement(RouteManager, { rootDiv: rootDiv }), [rootDiv]);
    (0, ignoreErrors_1.default)();
    return (react_1.default.createElement(AppStateController_1.default, Object.assign({}, appState),
        react_1.default.createElement(SelfController_1.default, null,
            react_1.default.createElement(SysLangController_1.default, null,
                react_1.default.createElement(NotificationController_1.default, null,
                    react_1.default.createElement(ViewController_1.default, null,
                        react_1.default.createElement(Spinner_1.default, { busy: false, whiteout: true, transition: 0.5, transitionDelay: 0.3 },
                            react_1.default.createElement(NotificationHandler_1.default, null),
                            content)))))));
}
exports.WebApp = WebApp;
exports.default = WebApp;
function RouteManager({ rootDiv }) {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const { replaceTo } = (0, useNav_1.default)();
    const { clearNotifications } = (0, useNotificationActions_1.default)();
    const self = (0, useSelf_1.default)();
    const auth = (0, react_useauth_1.default)();
    const history = (0, react_router_dom_1.useHistory)();
    const [initiated, setInitiated] = (0, react_1.useState)(false);
    const initiating = (0, react_1.useRef)(false);
    const _doSignout = (0, react_1.useMemo)(() => () => {
        clearNotifications();
        auth.api.signOut().catch(doNothing_1.default);
        if (!pathname.startsWith('/public'))
            replaceTo(lib_pages_1.default.ROOT);
        return null;
    }, [auth.api, clearNotifications, pathname, replaceTo]);
    const _doInit = (0, react_1.useMemo)(() => () => __awaiter(this, void 0, void 0, function* () {
        initiating.current = true;
        try {
            const initSelf = yield auth.api.init();
            if (initSelf && initSelf.visaType !== VisaType_1.default.GUEST) {
                yield auth.api.reloadSelf();
                history.listen(l => ga_1.default.pageview(l.pathname, self));
            }
            else {
                _doSignout();
            }
        }
        catch (_a) {
            _doSignout();
        }
        setInitiated(true);
    }), [_doSignout, auth.api, history, self]);
    // Handle Signout
    if (pathname.startsWith('/signout'))
        return _doSignout();
    // Handle Signup
    if (pathname.startsWith('/admin/signup'))
        return _doSignout();
    // Initialise
    if (!initiating.current)
        _doInit().catch(doNothing_1.default);
    if (!initiated)
        return react_1.default.createElement(Spinner_1.default, { busy: true });
    // Public Pages are always without navigation
    if (pathname.startsWith('/public')) {
        return react_1.default.createElement(PublicRoutes, null);
    }
    // Non Public Pages are absolutely layed on top of body
    Object.assign(rootDiv.style, {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: lib_palette_1.default.White.main,
    });
    // AUTHENTICATED USERS ARE SHOWN THE MENU
    if (self.id) {
        return (react_1.default.createElement(FullApp, null,
            react_1.default.createElement(AuthorizedRoutes, null)));
    }
    // NON AUTHENTICATED USERS AREN'T
    else {
        return (react_1.default.createElement(FullApp, null,
            react_1.default.createElement(NonAuthorizedRoutes, null)));
    }
}
function FullApp({ children }) {
    return (react_1.default.createElement(AlertWatcherController_1.default, null,
        react_1.default.createElement(TaskWatcherController_1.default, null,
            react_1.default.createElement(NewDataController_1.default, null,
                react_1.default.createElement(SelectionController_1.default, null,
                    react_1.default.createElement(WebAppDataManager_1.default, null, children))))));
}
function PublicRoutes() {
    const { routes } = (0, useAppState_1.default)();
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        routes
            .filter(route => route.public)
            .map((route, idx) => (react_1.default.createElement(react_router_dom_1.Route, Object.assign({ key: 'public' + idx }, route)))),
        react_1.default.createElement(react_router_dom_1.Route, { path: '*/nativeapp', render: props => react_1.default.createElement(RedirectToNativeAppPage_1.default, Object.assign({}, props)) })));
}
function AuthorizedRoutes() {
    var _a;
    const { routes, app, defaultRouteFor, getSpecialRouteFor } = (0, useAppState_1.default)();
    const self = (0, useSelf_1.default)();
    const realSelf = (0, useSelf_1.default)(true);
    (_a = window['loadZendeskWidget']) === null || _a === void 0 ? void 0 : _a.call(window);
    if (app === App_1.default.OPSBASE && !!window['zE']) {
        window['zE']('messenger', 'loginUser', cb => {
            cb(self.zenDeskJWTToken);
        });
    }
    let specialRoot = getSpecialRouteFor(self, realSelf);
    if (specialRoot) {
        return (react_1.default.createElement(WebAppRootWithHero_1.default, null,
            react_1.default.createElement(react_router_dom_1.Switch, null,
                routes
                    .filter(route => route.path === specialRoot)
                    .map((route, idx) => (react_1.default.createElement(FeaturedRoute_1.default, Object.assign({ key: idx }, route)))),
                react_1.default.createElement(react_router_dom_1.Redirect, { path: `*`, to: `${specialRoot}` }))));
    }
    else {
        return (react_1.default.createElement(WebAppRoot_1.default, { key: self.organisationId },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                routes
                    .filter(route => !route.public)
                    .filter(route => route.componentType === 'page' ||
                    route.componentType === 'standalone')
                    .map((route, idx) => (react_1.default.createElement(FeaturedRoute_1.default, Object.assign({ key: idx }, route)))),
                react_1.default.createElement(react_router_dom_1.Redirect, { path: `*`, to: `${defaultRouteFor(self, realSelf)}` })),
            routes
                .filter(route => route.componentType === 'dialog')
                .map((route, idx) => (react_1.default.createElement(FeaturedRoute_1.default, Object.assign({ key: idx }, route))))));
    }
}
function NonAuthorizedRoutes() {
    var _a;
    (_a = window['loadZendeskWidget']) === null || _a === void 0 ? void 0 : _a.call(window);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(WebAppRootWithHero_1.default, null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: `/fwd/:url`, render: props => {
                    forwardUrl(props.match.params.url).catch(err => lib_logger_1.default.error('Error in forwardUrl', err));
                    return react_1.default.createElement("div", null, "Redirecting");
                } }),
            react_1.default.createElement(react_router_dom_1.Route, { path: `*`, render: () => react_1.default.createElement(OTPSignIn_1.default, null) })))), []);
}
const forwardUrl = url => {
    return axios_1.default.get(`${lib_env_1.default.apis.webhooks}/fwd/${url}`);
};
